import React from 'react';
import { CheckboxContainer, CheckboxInput, CheckboxLabel, CheckboxInputWrapper } from './Checkbox.styles';

export interface CheckboxProps {
  checked: boolean;
  onChange: () => void;
  label: string;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  label,
  className
}) => {
  const inputId = React.useId();

  return (
    <CheckboxContainer className={className}>
      <CheckboxInputWrapper>
        <CheckboxInput
          id={inputId}
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />
      </CheckboxInputWrapper>
      <CheckboxLabel htmlFor={inputId}>{label}</CheckboxLabel>
    </CheckboxContainer>
  );
};

export default Checkbox;
